import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { CurrentContextService } from 'app/core/current-context.service';

@Pipe({
  name: 'toLocaleNumber',
  standalone: false,
})
export class FormatNumberPipe implements PipeTransform {
  constructor(
    private readonly currentContextService: CurrentContextService,
    private decimalPipe: DecimalPipe,
  ) {}

  transform(value: number, type?) {
    //for just %
    if (type === '%') {
      return this.setFormatNumberPercent(value);
    }
    //for a number, optionally with an Angular DecimalPipe digitsInfo string (e.g. '1.2-2')
    return this.setFormatNumber(this.currentContextService.currentContext?.user, value, type);
  }

  private setFormatNumber(user, val, digitsInfo?: string) {
    if (typeof val === 'string') {
      val = +val.replace(/\s/g, '').replace(/,/g, '');
    }
    if (user?.timeZoneId.indexOf('America') !== -1) {
      return this.decimalPipe.transform(val, digitsInfo ?? '', 'en-US');
    } else {
      return this.decimalPipe.transform(val, digitsInfo ?? '', 'sv-SE');
    }
  }

  private setFormatNumberPercent(val) {
    if (val >= 10 && val <= 100) {
      return parseFloat(val.toFixed(1));
    } else if (val < 10) {
      return parseFloat(val.toFixed(2));
    } else if (val > 100) {
      return parseFloat(val.toFixed());
    }
  }
}
